import React, { useEffect, useRef } from "react";
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import { fromLonLat } from "ol/proj";
import { coordinatesArray } from "./StormSurgeViewSimulationMap";
import StormSurgeForecastMapRightSideButtons from "./StormSurgeForecastMapRightSideButtons";
import StormSurgeForecastTimeline from "./StormSurgeForecastTimeline";
// import ForecastMapRightSideButtons from "./ForecastMapRightSideButtons/ForecastMapRightSideButtons";
// import ForecastTimeline from "../ForecastTimeline/ForecastTimeline";


const StormSurgeViewForecastMap = () => {
  const mapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (mapRef.current) {
      const raster = new TileLayer({
        source: new OSM(),
      });

      const polyCoords2 = [coordinatesArray];

      const geojsonObject = {
        type: "FeatureCollection",
        crs: {
          type: "name",
          properties: {
            name: "EPSG:3857",
          },
        },
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Polygon",
              coordinates: polyCoords2,
            },
          },
        ],
      };
      const showPolygon = new VectorSource({
        features: new GeoJSON().readFeatures(geojsonObject),
      });

      // const vectorPolygon = new VectorLayer({
      //   source: showPolygon,
      // });

      const source = new VectorSource({ wrapX: false });

      const vector = new VectorLayer({
        source: source,
      });
      const map = new Map({
        layers: [raster, vector],
        controls: [],
        target: mapRef.current,
        view: new View({
          center: fromLonLat([80.7718, 7.8731]),
          zoom: 7,
        }),
      });
      return () => {
        map.setTarget(undefined);
      };
    }
  }, []);

  return (
    <div style={{ height: "100%", position: "relative" }}>
      <div style={{ height: "100%" }} id="map" ref={mapRef}></div>
      <div style={{ position: "absolute", /* top: "65%" */top: "52%", right:"3%"}}>
          <StormSurgeForecastMapRightSideButtons />
        </div>
        <div style={{ position: "absolute", bottom: "1%", left:"0%", width:"90%"}}>
        <StormSurgeForecastTimeline />
        </div>
    </div>
  );
};
/* <ForecastTimeline /> */
export default StormSurgeViewForecastMap;
